import React from 'react';
import {
  Box,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemButton,
  Divider,
  Alert,
} from '@mui/material';
import {
  Event,
  ArrowForward
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/it';

// Set Italian locale
dayjs.locale('it');

const CalendarList = ({ courses, selectedDate, onCourseClick, isClickable = true }) => {
  const navigate = useNavigate();

  // Get courses for the selected date
  const getCoursesForDate = (date) => {
    if (!date || !courses || !Array.isArray(courses)) return [];
    
    const dateStr = dayjs(date).format('YYYY-MM-DD');
    return courses.filter(course => 
      course.dates && Array.isArray(course.dates) && course.dates.some(courseDate => 
        courseDate && dayjs(courseDate).format('YYYY-MM-DD') === dateStr
      )
    );
  };

  const coursesForSelectedDate = getCoursesForDate(selectedDate);

  const handleCourseClick = (courseId) => {
    if (!isClickable) return;
    
    if (onCourseClick) {
      onCourseClick(courseId);
    } else {
      navigate(`/teacher/course/${courseId}`);
    }
  };

  if (!selectedDate) {
    return (
      <Paper elevation={2} sx={{ p: 2, height: '100%'}}>
        <Typography variant="h6" gutterBottom>
          Seleziona una data dal calendario
        </Typography>
        <Alert severity="info">
          Clicca su un giorno nel calendario per vedere i corsi di quella data
        </Alert>
      </Paper>
    );
  }

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Event sx={{ mr: 1, color: 'primary.main' }} />
        <Typography variant="h6">
          Corsi del {dayjs(selectedDate).format('DD MMMM YYYY')}
        </Typography>
      </Box>

      {coursesForSelectedDate.length === 0 ? (
        <Alert severity="info">
          Nessun corso programmato per questa data
        </Alert>
      ) : (
        <List sx={{ p: 0 }}>
          {coursesForSelectedDate.map((course, index) => (
            <React.Fragment key={course._id}>
              <ListItem sx={{ p: 0, mb: 0.5 }}>
                <ListItemButton 
                  onClick={() => handleCourseClick(course._id)}
                  sx={{ 
                    p: 1.5, 
                    borderRadius: 1,
                    ...(isClickable ? {
                      '&:hover': {
                        backgroundColor: 'action.hover',
                        transform: 'scale(1.02)',
                        transition: 'all 0.2s'
                      }
                    } : {
                      cursor: 'default',
                      '&:hover': {
                        backgroundColor: 'transparent',
                        transform: 'none'
                      }
                    })
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                      {course.name} {course.minLevel ? `(${course.minLevel}° anno)` : ''}
                    </Typography>
                    
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
                      {course.venue} • {course.time || ''}
                    </Typography>
                  </Box>
                  {isClickable && <ArrowForward sx={{ fontSize: 16, color: 'primary.main' }} />}
                </ListItemButton>
              </ListItem>
              {index < coursesForSelectedDate.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      )}
    </Paper>
  );
};

export default CalendarList; 